import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import { Button } from "web/react/emo/button";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import { FeedPromotionsSerializer } from "web/types/serializers";
import * as styles from "./promotion-summary.css";

export interface PromotionSummaryProps {
    promotions: FeedPromotionsSerializer;
}

export function PromotionSummary({ promotions }: PromotionSummaryProps): React.ReactElement {
    const { active_promotions } = promotions;

    return (
        <>
            <div className={styles.promotionSummaryContainer}>
                <div className={styles.promoSummaryTextWrapper}>
                    <SVGIcon name="tag-fill" className={styles.tagIcon} flip />
                    <Text as="p" textStyle="body-s">
                        {gettext("promotion_message.promotion_text.active_promotions", {
                            number: active_promotions.length.toString(),
                        })}
                    </Text>
                </div>
                <Button
                    title={gettext("promotion.button.see_all")}
                    size={"sm"}
                    variant={"primary"}
                />
            </div>
        </>
    );
}
